<nz-card>
  <div class="row">
    <div class="col-12 col-lg-3 stat-tiles">
      <!--      project-->
      <div
        class="single-stats-box d-flex align-items-center mb-1"
        style="background-color: #d9f0e3; cursor: pointer"
        (click)="onProjectClick()"
      >
        <div class="d-flex justify-content-center bd-highlight mb-3">
          <div class="p-2 bd-highlight">
            <div class="icon">
              <i nz-icon nzType="file-done" nzTheme="outline"> </i>
            </div>
          </div>
          <div class="p-2 bd-highlight">
            <h3>{{ dashboardDetails?.projectCount }}</h3>
            <span class="d-block"> Project</span>
          </div>
        </div>
      </div>

      <!--      &lt;!&ndash;      accredited course&ndash;&gt;-->
      <!--      <div class="single-stats-box d-md-flex align-items-cente mb-1" style="background-color:#E7E9F6FF">-->
      <!--        <div class="icon">-->
      <!--          <i nz-icon nzType="exception" nzTheme="outline"> </i>-->
      <!--        </div>-->
      <!--        <div>-->
      <!--          <h3>-->
      <!--            {{ dashboardDetails?.accreditedCourse }}-->
      <!--          </h3>-->
      <!--          <span class="d-block">-->
      <!--                    Courses Accredited-->
      <!--                </span>-->
      <!--        </div>-->
      <!--      </div>-->

      <!--      course-->
      <div
        class="single-stats-box d-flex align-items-center mb-1"
        style="background-color: #f3e5e0; cursor: pointer"
        (click)="onCourseClick()"
      >
        <div class="d-flex justify-content-center bd-highlight mb-3">
          <div class="p-2 bd-highlight">
            <div class="icon">
              <i nz-icon nzType="book" nzTheme="outline"> </i>
            </div>
          </div>
          <div class="p-2 bd-highlight">
            <h3>{{ dashboardDetails?.courseCount }}</h3>
            <span class="d-block"> Courses</span>
          </div>
        </div>
      </div>

      <!--      batch-->
      <div
        class="single-stats-box d-flex align-items-center mb-1"
        style="background-color: #e1dff0; cursor: pointer"
        (click)="onBatchClick()"
      >
        <div class="d-flex justify-content-center bd-highlight mb-3">
          <div class="p-2 bd-highlight">
            <div class="icon">
              <i nz-icon nzType="cluster" nzTheme="outline"> </i>
            </div>
          </div>
          <div class="p-2 bd-highlight">
            <h3>{{ dashboardDetails?.batchCount }}</h3>
            <span class="d-block"> Batch</span>
          </div>
        </div>
      </div>

      <!--      trainer-->

      <div
        class="single-stats-box d-flex align-items-center mb-1"
        style="background-color: #d5e0eb; cursor: pointer"
        (click)="onTrainerClick()"
      >
        <div class="d-flex justify-content-center bd-highlight mb-3">
          <div class="p-2 bd-highlight">
            <div class="icon">
              <i nz-icon nzType="usergroup-add" nzTheme="outline"> </i>
            </div>
          </div>
          <div class="p-2 bd-highlight">
            <h3>{{ dashboardDetails?.trainer }}</h3>
            <span class="d-block"> Trainer</span>
          </div>
        </div>
      </div>

      <!--      Expiring Occupations-->

      <div
        class="single-stats-box d-flex align-items-center mb-1"
        style="background-color: #e2e1db; cursor: pointer"
        (click)="onExpiringSoonClick()"
      >
        <div class="d-flex justify-content-center bd-highlight mb-3">
          <div class="p-2 bd-highlight">
            <div class="icon">
              <i nz-icon nzType="clock-circle" nzTheme="outline"></i>
            </div>
          </div>
          <div class="p-2 bd-highlight">
            <h3>{{ expiringSoonOccupations }}</h3>
            <span class="d-block"> Expiring Soon Occupations</span>
          </div>
        </div>
      </div>

      <!--      Expired Occupations-->

      <div
        class="single-stats-box d-flex align-items-center mb-1"
        style="background-color: #d4e4e1; cursor: pointer"
        (click)="onExpiredOccupationsClick()"
      >
        <div class="d-flex justify-content-center bd-highlight mb-3">
          <div class="p-2 bd-highlight">
            <div class="icon">
              <i nz-icon nzType="warning" nzTheme="outline"></i>
            </div>
          </div>
          <div class="p-2 bd-highlight">
            <h3>{{ expiredOccupations }}</h3>
            <span class="d-block">Expired Occupations</span>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-lg-9">
      <div class="my-1">
        <div class="row">
          <!-- Valid: the expiry date and when the renewal opens (90 days before it) -->
          <div class="col-12" *ngIf="isStpValid">
            <div
              class="single-stats-box expiry-alert d-md-flex justify-content-between align-items-center my-1 p-3 rounded shadow-sm"
              style="background-color: #d4edda; border-left: 6px solid #28a745"
            >
              <div class="d-flex align-items-center">
                <div class="icon me-3">
                  <i nz-icon nzType="safety-certificate" nzTheme="outline" style="font-size: 28px"></i>
                </div>
                <div>
                  <span class="fw-bold d-block text-dark">STP Registration Valid Until</span>
                  <h4 class="mb-1 text-success">{{ stpExpireDate | date : "dd MMM yyyy" }}</h4>
                  <small class="text-muted">
                    {{ stpExpiresIn }} days left. Renewal opens 90 days before the expiry date.
                  </small>
                </div>
              </div>
            </div>
          </div>

          <!-- Expiring Soon -->
          <div class="col-12" *ngIf="isStpExpiringSoon">
            <div
              class="single-stats-box expiry-alert d-md-flex justify-content-between align-items-center my-1 p-3 rounded shadow-sm"
              style="background-color: #fff3cd; border-left: 6px solid #e6de10"
            >
              <!-- Left content: Expiring Soon opens the Application List (where the Renew button is) -->
              <div
                class="d-flex align-items-center"
                style="cursor: pointer"
                title="Expiring Soon: open the Application List"
                (click)="redirectToApplication()"
              >
                <div class="icon me-3">
                  <i
                    nz-icon
                    nzType="field-time"
                    nzTheme="outline"
                    style="font-size: 28px"
                  ></i>
                </div>
                <div>
                  <span class="fw-bold d-block text-dark">STP Expires In</span>
                  <span class="badge" style="background-color: #e6de10; color: #000; font-size: 10px">
                    Expiring Soon
                  </span>
                  <h4 class="mb-1 text-warning">
                    {{ stpExpiresIn === 0 ? 'Today' : stpExpiresIn + ' Days' }}
                  </h4>
                  <small class="text-muted"
                    >Expiry Date:
                    {{ stpExpireDate | date : "dd MMM yyyy" }}</small
                  >
                </div>
              </div>

              <!-- Right button -->
              <!-- Renewal already started: continue it. Otherwise start a new renewal after confirming. -->
              <button
                *ngIf="isRenewalInProgress; else startRenewalBtn"
                nz-button
                nzType="primary"
                nzSize="default"
                class="rounded d-flex align-items-center"
                (click)="openRenewalApplication()"
              >
                <i nz-icon nzType="reload" nzTheme="outline" class="me-1"></i>
                Continue Renewal Application
              </button>
              <ng-template #startRenewalBtn>
                <button
                  nz-button
                  nzType="primary"
                  nzSize="default"
                  class="rounded d-flex align-items-center"
                  [nzLoading]="isRenewing"
                  nz-popconfirm
                  nzPopconfirmTitle="Start the STP/SAC registration renewal application? Your current information will be copied into a new renewal application that you can review and submit."
                  nzPopconfirmPlacement="bottomRight"
                  (nzOnConfirm)="startRenewal()"
                >
                  <i nz-icon nzType="reload" nzTheme="outline" class="me-1"></i>
                  Expiring Soon → Click to Renew
                </button>
              </ng-template>
            </div>
          </div>

          <!-- Expired -->
          <div class="col-12" *ngIf="isStpExpired">
            <div
              class="single-stats-box expiry-alert d-md-flex justify-content-between align-items-center my-1 p-3 rounded shadow-sm"
              style="background-color: #f8d7da; border-left: 6px solid #db3d28"
            >
              <!-- Left content -->
              <div class="d-flex align-items-center">
                <div class="icon me-3">
                  <i
                    nz-icon
                    nzType="field-time"
                    nzTheme="outline"
                    style="font-size: 28px"
                  ></i>
                </div>
                <div>
                  <span class="fw-bold d-block text-dark">STP Status</span>
                  <h4 class="mb-1 text-danger">
                    {{ stpExpiryStatus?.reason === 'EXPIRED' ? 'Expired!' : 'Not Active' }}
                  </h4>
                  <small class="text-muted" *ngIf="stpExpiryStatus?.reason === 'EXPIRED'"
                    >Expired On:
                    {{ stpExpireDate | date : "dd MMM yyyy" }}</small
                  >
                </div>
              </div>

              <!-- Right button: an expired STP renews directly (or continues a renewal already started);
                   a not-approved STP has no renewal, so it goes to its application list. -->
              <ng-container *ngIf="stpExpiryStatus?.reason === 'EXPIRED'; else notActiveBtn">
                <button
                  *ngIf="isRenewalInProgress; else startExpiredRenewalBtn"
                  nz-button
                  nzType="danger"
                  nzSize="default"
                  class="rounded d-flex align-items-center"
                  (click)="openRenewalApplication()"
                >
                  <i nz-icon nzType="reload" nzTheme="outline" class="me-1"></i>
                  Continue Renewal Application
                </button>
                <ng-template #startExpiredRenewalBtn>
                  <button
                    nz-button
                    nzType="danger"
                    nzSize="default"
                    class="rounded d-flex align-items-center"
                    [nzLoading]="isRenewing"
                    nz-popconfirm
                    nzPopconfirmTitle="Start the STP/SAC registration renewal application? Your current information will be copied into a new renewal application that you can review and submit."
                    nzPopconfirmPlacement="bottomRight"
                    (nzOnConfirm)="startRenewal()"
                  >
                    <i nz-icon nzType="reload" nzTheme="outline" class="me-1"></i>
                    Click to Renew
                  </button>
                </ng-template>
              </ng-container>
              <ng-template #notActiveBtn>
                <button
                  nz-button
                  nzType="danger"
                  nzSize="default"
                  class="rounded d-flex align-items-center"
                  (click)="redirectToApplication()"
                >
                  <i nz-icon nzType="exclamation-circle" nzTheme="outline" class="me-1"></i>
                  Go to Application
                </button>
              </ng-template>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-4">
            <div class="mb-2">
              <div
                class="single-stats-header d-md-flex align-items-center my-1"
                style="background-color: #4573a4; color: #fff"
              >
                <div class="d-flex justify-content-start bd-highlight mb-3">
                  <div class="icon">
                    <i nz-icon nzType="usergroup-add" nzTheme="outline"></i>
                  </div>
                  <b>Enrolled {{ dashboardDetails?.enrTolalTrainees }}</b>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-4">
            <div
              class="single-stats-header d-md-flex align-items-center my-1"
              style="background-color: #4573a4; color: #fff"
            >
              <div class="d-flex justify-content-start bd-highlight mb-3">
                <div class="icon">
                  <i nz-icon nzType="usergroup-add" nzTheme="outline"> </i>
                </div>
                <b>RPL {{ dashboardDetails?.totalRplTrainees }}</b>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div
              class="single-stats-header d-md-flex align-items-center my-1"
              style="background-color: #4573a4; color: #fff"
            >
              <div class="d-flex justify-content-start bd-highlight mb-3">
                <div class="icon">
                  <i nz-icon nzType="usergroup-add" nzTheme="outline"> </i>
                </div>
                <b>Regular {{ dashboardDetails?.totalRegTrainees }}</b>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 col-lg-6 col-sm-12">
            <nz-card style="border-radius: 10px">
              <span
                >Male {{ dashboardDetails?.enrMale }}
                <span class="float-right">({{ enrolledMalePerc }} )</span></span
              >
              <br />
              <span
                >Female {{ dashboardDetails?.enrFemale }}
                <span class="float-right">({{ enrolledFemalePerc }})</span>
                <br />
                <span
                  >Others {{ dashboardDetails?.enrOthers }}
                  <span class="float-right"
                    >({{ enrolledOthersPerc }} )</span
                  ></span
                ></span
              >
            </nz-card>
          </div>
          <div class="col-md-6 col-lg-6 col-sm-12">
            <nz-card style="border-radius: 10px">
              <span
                >PWD {{ dashboardDetails?.enrPwd }}
                <span class="float-right">({{ enrolledPwdPerc }})</span></span
              >
              <br />
              <span
                >Marginalized {{ dashboardDetails?.enrMarginalized }}
                <span class="float-right">({{ enrolledMargPerc }} )</span></span
              >
              <br />
              <span>&nbsp;</span>
            </nz-card>
          </div>
        </div>
      </div>

      <div class="mb-1">
        <div class="mb-2">
          <div
            class="single-stats-header d-md-flex align-items-center my-1"
            style="background-color: #93a445"
          >
            <div class="icon">
              <i nz-icon nzType="book" nzTheme="outline"> </i>
            </div>
            <div>
              <h3>
                <b
                  >Graduated {{ dashboardDetails?.grdTolalTrainees }} ({{
                    graduateddPerc
                  }})</b
                >
              </h3>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-lg-4 col-sm-12">
            <nz-card style="border-radius: 10px">
              <span
                >Male {{ dashboardDetails?.grdMale }}
                <span class="float-right"
                  >({{ graduatedMalePerc }} )</span
                ></span
              >
              <br />
              <span
                >Female {{ dashboardDetails?.grdFemale }}
                <span class="float-right">({{ graduatedFemalePerc }} )</span>
                <br />
                <span
                  >Others {{ dashboardDetails?.grdOthers }}
                  <span class="float-right"
                    >({{ graduatedOthersPerc }} )</span
                  ></span
                ></span
              >
            </nz-card>
          </div>
          <div class="col-md-4 col-lg-4 col-sm-12">
            <nz-card style="border-radius: 10px">
              <span
                >PWD {{ dashboardDetails?.grdPwd }}
                <span class="float-right">({{ graduatedPwdPerc }})</span></span
              >
              <br />
              <span
                >Marginalized {{ dashboardDetails?.grdMarginalized }}
                <span class="float-right"
                  >({{ graduatedMargPerc }} )</span
                ></span
              >
            </nz-card>

            <nz-card style="border-radius: 10px" class="mt-1">
              <span>Drop-out {{ dashboardDetails?.enrDropOutCount }} </span>
            </nz-card>
          </div>
          <div class="col-md-4 col-lg-4 col-sm-12">
            <nz-card nzTitle="Re-assessment" style="border-radius: 10px">
              <span>Male {{ dashboardDetails?.raMale }} </span>
              <br />
              <span>Female {{ dashboardDetails?.raFemale }} </span>
              <br />
              <span>Total {{ dashboardDetails?.raTotal }} </span>
            </nz-card>
          </div>
        </div>
      </div>

      <div class="mb-2">
        <div
          class="single-stats-header d-md-flex align-items-center my-1"
          style="background-color: #7e45a4"
        >
          <div class="icon">
            <i nz-icon nzType="safety-certificate" nzTheme="outline"> </i>
          </div>
          <div>
            <h3>
              <b
                >Employed
                {{
                  dashboardDetails?.wageEmpTotal +
                    dashboardDetails?.selfEmpTotal
                }}</b
              >
            </h3>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 col-lg-4 col-sm-12">
          <nz-card nzTitle="Self" style="border-radius: 10px">
            <span
              >Male {{ dashboardDetails?.selfEmpMale }}
              <!--              <span class="float-right">({{ selfEmpMalePerc }}-->
              <!--              )</span>-->
            </span>
            <br />
            <span
              >Female {{ dashboardDetails?.selfEmpFemale }}
              <!--              <span class="float-right">({{ selfEmpFemalePerc }}-->
              <!--              )</span>-->
            </span>
          </nz-card>
        </div>
        <div class="col-md-4 col-lg-4 col-sm-12">
          <nz-card nzTitle="Wage" style="border-radius: 10px">
            <span
              >Male {{ dashboardDetails?.wageEmpMale }}
              <!--              <span class="float-right">({{ wageEmpMalePerc }}-->
              <!--              )</span>-->
            </span>
            <br />
            <span
              >Female {{ dashboardDetails?.wageEmpFemale }}
              <!--              <span class="float-right">({{ wageEmpFemalePerc }}-->
              <!--              )</span>-->
            </span>
          </nz-card>
        </div>
        <div class="col-md-4 col-lg-4 col-sm-12">
          <nz-card nzTitle="Overseas" style="border-radius: 10px">
            <span>Male N/A </span>
            <br />
            <span>Female N/A </span>
          </nz-card>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 col-md-6">
      <div class="my-1">
        <div class="mb-2">
          <a
            routerLink="/home/course-accreditation/course-accreditation-list/eCertifcates"
            target="_blank"
          >
            <div
              class="single-stats-header d-md-flex align-items-center my-1"
              style="background-color: #a46945"
            >
              <!--            <div class="icon">-->
              <!--              <i nz-icon nzType="usergroup-add" nzTheme="outline"> </i>-->
              <!--            </div>-->
              <div>
                <h3>
                  <b>Link to e-Certificates</b>
                </h3>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6">
      <div class="my-1">
        <div class="mb-2">
          <a routerLink="/home/payment/stp-payment-history" target="_blank">
            <div
              class="single-stats-header d-md-flex align-items-center my-1"
              style="background-color: #a46945"
            >
              <!--            <div class="icon">-->
              <!--              <i nz-icon nzType="usergroup-add" nzTheme="outline"> </i>-->
              <!--            </div>-->
              <div>
                <h3>
                  <b>Link to Payments</b>
                </h3>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</nz-card>
